export default __webpack_public_path__ + "static/0026-040c98b62f34886e33e77cad3f1525cf.png";